import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sda-unauthorized',
  standalone: true,
  templateUrl: './unauthorized.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {}
